import React from "react";
import {AOperation} from "../../../models/operations/AOperation";
import DisplayOperationForValidation from "./DisplayOperationForValidation";
import ValidationButton from "../../utils/buttons/ValidationButton";
import {Button} from "@mui/material";
import {Undo} from "@mui/icons-material";
import './ValidationStep.css';
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    onBack: () => void,
    onValidate: () => void,
    operation: AOperation
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 28/03/2022
 * @last_update 28/03/2022
 **/
class ValidationStep extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <div>
                <h1 id="validation-step-title">{getTranslation("steps.validation.title")}</h1>
                <DisplayOperationForValidation operation={this.props.operation}/>
                <div id="validation-step-button-container">
                    <Button
                        color="error"
                        variant="contained"
                        onClick={this.props.onBack}
                        startIcon={<Undo/>}
                        size="large"
                        id="validation-step-cancel-button"
                    >
                        {getTranslation("steps.validation.back-button")}
                    </Button>
                    <ValidationButton id="validation-step-validation-button" onClick={this.props.onValidate}/>
                </div>
            </div>

        );

    };

}

export default withTranslation()(ValidationStep);
